import { UserTimezone } from "app/main/signing-pages/signing-page/signing-page.dto";

export const defaultTimeZone: UserTimezone = {
    "timezone": "Europe/Amsterdam",
    "month_format": 0,
    "date_format": "YYYY-MM-DD",
    "hours_format": "24 hours",
}